import { Grid } from "@mui/material";

import {
  Block,
  CheckTitle,
  HighlightBlock,
  HighlightText,
  TeethIcon,
} from "../styles/ProductsStyles";

import { loadLocalImage } from "../../../../../utils";
import type { ProductCheckItem } from "./ProductsTypes";

export type CheckItemsProps = {
  checkItems?: ProductCheckItem[];
};

export function CheckItems({ checkItems = [] }: Readonly<CheckItemsProps>) {
  if (!checkItems.length) {
    return null;
  }

  return (
    <Grid
      container
      flexDirection="column"
      aria-label="Benefícios do produto"
    >
      {checkItems.map((item, index) => {
        const isHighlighted = index === 0;
        const iconSrc = loadLocalImage(item.icon, "", "");

        return (
          <Grid key={`checkitems_${item.id}`}>
            {isHighlighted ? (
              <HighlightBlock>
                <TeethIcon src={iconSrc} alt="" aria-hidden="true" />
                <HighlightText>{item.text}</HighlightText>
              </HighlightBlock>
            ) : (
              <Block>
                <TeethIcon src={iconSrc} alt="" aria-hidden="true" />
                <CheckTitle>{item.text}</CheckTitle>
              </Block>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
}

export default CheckItems;